export const encodeQuery = (
  url: string,
  params: { [name: string]: string | number | boolean | number[] | string[] },
) => {
  let query = url + '?';
  for (const d in params) {
    if (Array.isArray(params[d]) && params[d]?.length > 0) {
      query +=
        encodeURIComponent(d) +
        '=' +
        encodeURIComponent(params[d]?.join(',')) +
        '&';
    } else if (
      (!Array.isArray(params[d]) && params[d]) ||
      params[d] === false
    ) {
      query +=
        encodeURIComponent(d) + '=' + encodeURIComponent(params[d]) + '&';
    }
  }
  return query.slice(0, -1);
};
